import { motion } from "framer-motion";
import { ASSETS } from "@/constants/assets";

const DOMAINS = [
  { num: "01", name: "Metabolic" },
  { num: "02", name: "Hormonal" },
  { num: "03", name: "Inflammatory" },
  { num: "04", name: "Sleep/Circadian" },
  { num: "05", name: "Stress/Autonomic" },
  { num: "06", name: "Gut/Nutrient" },
  { num: "07", name: "Mitochondrial" },
  { num: "08", name: "Recovery" },
  { num: "09", name: "Cardiovascular" },
  { num: "10", name: "Neurocognitive" },
  { num: "11", name: "Detoxification" },
];

export const DomainsSection = () => (
  <section id="domains" className="relative z-[1] py-28 lg:py-36 px-6 lg:px-12 overflow-hidden bg-gradient-to-b from-[#030B18] via-[#0A1628] to-[#030B18]" data-testid="domains-section">
    <div className="logo-watermark-section">
      <img src={ASSETS.logo} alt="" className="logo-glow-intense" />
    </div>
    <div className="max-w-[1200px] mx-auto relative z-[2]">
      <motion.div
        className="bg-[rgba(3,11,24,0.92)] p-8 rounded-xl mb-12 max-w-[700px]"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <div className="font-orbitron text-sm font-semibold tracking-[5px] uppercase text-[#60A5FA] mb-4 text-shadow">
          Integrated Matrix Engine
        </div>
        <h2 className="font-orbitron text-3xl sm:text-4xl lg:text-5xl font-bold tracking-[3px] leading-tight mb-5 text-white text-shadow">
          Multi-Domain Analysis
        </h2>
        <p className="font-outfit text-xl font-light leading-relaxed text-white/90">
          Maps each patient across multiple clinical domains, generating composite scores, flags, and pattern recognition as a decision support layer.
        </p>
      </motion.div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
        {DOMAINS.map((domain, i) => (
          <motion.div
            key={i}
            className="domain-chip font-orbitron text-xs font-medium tracking-[2px] uppercase py-5 px-5 bg-[rgba(10,22,40,0.95)] border-2 border-[#3B82F6]/40 rounded text-center text-white cursor-default"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
            data-testid={`domain-${domain.num}`}
          >
            <span className="block text-2xl lg:text-3xl font-extrabold mb-2 text-[#60A5FA]">{domain.num}</span>
            {domain.name}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
